import React from 'react';

const ComingSoon = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center p-4">
      <div className="max-w-4xl w-full text-center space-y-12">
        
        {/* Logo */}
        <div className="animate-fade-in">
          <h1 className="text-5xl md:text-7xl font-serif text-white mb-4">
            Ashbourne Law
          </h1>
          <div className="h-1 w-32 bg-white mx-auto"></div>
        </div>

        {/* Main Image/Icon */}
        <div className="animate-fade-in-delay-1">
          <div className="w-48 h-48 mx-auto mb-8 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm border border-white/20">
            <svg 
              className="w-24 h-24 text-white"
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={1.5} 
                d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" 
              />
            </svg>
          </div>
        </div>

        {/* Coming Soon Text */}
        <div className="space-y-6 animate-fade-in-delay-2">
          <h2 className="text-4xl md:text-6xl font-bold text-white">
            Coming Soon
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
            International Boutique Law Firm
          </p>
          <p className="text-lg text-gray-400 max-w-xl mx-auto">
            We're crafting something exceptional. Our new digital presence will be launching soon.
          </p>
        </div>

        {/* Optional: Email Notification */}
        <div className="animate-fade-in-delay-3 max-w-md mx-auto">
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-6">
            <p className="text-gray-300 mb-4">Get notified when we launch</p>
            <div className="flex gap-3">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-white/50"
              />
              <button className="px-6 py-3 bg-white text-gray-900 rounded-lg font-medium hover:bg-gray-100 transition-colors">
                Notify Me
              </button>
            </div>
          </div>
        </div>

        {/* Contact Info */}
        <div className="animate-fade-in-delay-4 text-gray-400 space-y-2">
          <p>For inquiries: contact@ashbournelaw.com</p>
          <p className="text-sm">© 2024 Ashbourne Law. All rights reserved.</p>
        </div>

      </div>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fadeIn 1s ease-out;
        }

        .animate-fade-in-delay-1 {
          animation: fadeIn 1s ease-out 0.3s both;
        }

        .animate-fade-in-delay-2 {
          animation: fadeIn 1s ease-out 0.6s both;
        }

        .animate-fade-in-delay-3 {
          animation: fadeIn 1s ease-out 0.9s both;
        }

        .animate-fade-in-delay-4 {
          animation: fadeIn 1s ease-out 1.2s both;
        }
      `}</style>
    </div>
  );
};

export default ComingSoon;
